import styled from '@emotion/styled';

import MemoOffIcon from '@/assets/icons/icon_memo_off.svg';
import MemoOnIcon from '@/assets/icons/icon_memo_on.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

const BaseMemoIcon = styled.i(() =>
  mq({
    display: 'inline-block',
    marginLeft: defaultTheme.spacing.xs,
    marginBottom: '-1px',
    width: '12px',
    height: '14px',
    cursor: 'pointer',
    ...hoverOpacity,
  }),
);

export const MemoOn = styled(BaseMemoIcon)(() =>
  mq({
    background: `url(${MemoOnIcon}) no-repeat center`,
  }),
);

export const MemoOff = styled(BaseMemoIcon)(() =>
  mq({
    background: `url(${MemoOffIcon}) no-repeat center`,
  }),
);
